import {useAuth0} from "@auth0/auth0-react";
import {space} from "./compiled";
import RequestEnvelopeProto = space.kenko.proto.RequestEnvelopeProto;
import {useAuthUtil} from "./util/AuthUtil";
import {getBookingServer} from "./util/HostUtil";

type RpcSender = {
  send: (method: string, request: Uint8Array) => Promise<Uint8Array>;
}

export const useRpcSender = () : RpcSender => {

  const {getIdTokenClaims} = useAuth0();

  const {auth0Login} = useAuthUtil()
  
  return {
    send: (method: string, request: Uint8Array) => {
      return new Promise(async (resolve, reject) => {

        // Add some time to localhost for testing.
        const testTimeout = window.location.host.indexOf("localhost") >= 0 ? 1000 : 0;
        await new Promise(resolve => setTimeout(resolve, testTimeout));

        getIdTokenClaims().then(token => {

          console.log("[SendRpc] sending " + method + " request");

          const url = getBookingServer() + '/action/' + method;

          fetch(url, {
            headers: {
              'Authentication': token?.__raw ?? ''
            },
            method: 'POST',
            body: RequestEnvelopeProto.encode(new RequestEnvelopeProto({
              authToken: token?.__raw,
              requestMessage: request
            })).finish()
          })
              .then(response => {

                // This is unauthorized from our server. This means the auth cookie is no longer valid
                // and an auth0 login is required.
                if (response.status == 401) {
                  console.log('[SendRpc] received ' + method + ' response with status ' + response.status)
                  auth0Login();
                  reject('Please log in.');
                }

                if (response.status != 200) {
                  reject('Status code ' + response.status);
                }

                response.arrayBuffer()
                    .then(buffer => {
                      resolve(new Uint8Array(buffer));
                    })
                    .catch(error => {
                      console.warn("[SendRpc] error reading response body" + method, error);
                      reject('Data read error');
                    });
              })
              .catch(e => {
                console.warn('[SendRpc] error in http layer ' + method, e);
                reject('Network error');
              });
        }).catch(e => {
          reject(e);
        })
      });
    }
  }
}
